// Presentation-only examples from the sibling products. Source references and
// asset attribution live in public/assets/landing/SOURCES.md.
export const servicePreview = {
  professional: "Forma Studio",
  logo: "/assets/landing/logo-forma-studio.svg",
  title: "Brand identity design",
  price: "₦35K – ₦55K",
  location: "Lagos, Nigeria",
  rating: "4.5",
  reviews: "2",
  image: "/assets/landing/brand-identity.svg",
  professionals: [
    { name: "Amara", role: "Photographer", avatar: "/assets/landing/avatar-amara.webp" },
    { name: "Daniel", role: "Brand designer", avatar: "/assets/landing/avatar-daniel.webp" },
    { name: "Lina", role: "Event planner", avatar: "/assets/landing/avatar-lina.webp" },
  ],
};

export const businessWorkspaces = [
  { name: "Forma Studio", area: "Services", role: "Owner", logo: "/assets/landing/logo-forma-studio.svg" },
  { name: "Lagos Live", area: "Events", role: "Team member", logo: "/assets/landing/logo-lagos-live.svg" },
];

export const dealPreview = {
  title: "Croissant box of six",
  vendor: "Golden Crust Bakery",
  area: "Maitama",
  price: "₦4,500",
  referencePrice: "₦7,200",
  savings: "Save 38%",
  quantity: "6 left",
  pickup: "Today 8pm to 11pm",
  image: "/assets/landing/croissants.webp",
};
